"use client";

import { ArrowRight, Repeat2 } from "lucide-react";
import { useTranslations } from "next-intl";

/**
 * `EX-RTW03`, board D: the three-line box over a run-twice statement. What a
 * contestant has to know before reading the rest: two runs, nothing carried
 * between them but what the jury hands over, and limits per run. The same box
 * on the practice and the contest page; a standard problem never renders it.
 */
export function RunTwiceExplainer() {
  const t = useTranslations("judge.runTwice");
  return (
    <section
      aria-labelledby="run-twice-explainer-title"
      className="grid gap-3 rounded-xl border border-primary/25 bg-gradient-to-br from-primary/[0.06] to-white p-4"
      data-testid="run-twice-explainer"
    >
      <h2 id="run-twice-explainer-title" className="flex items-center gap-2 text-[15px] font-bold text-neutral-900">
        <Repeat2 className="h-4 w-4 text-primary" aria-hidden />
        {t("explainerTitle")}
      </h2>
      <div className="flex flex-wrap items-center gap-1.5 text-xs" aria-hidden>
        <span className="rounded-md border border-neutral-200 bg-white px-2 py-1 font-medium text-neutral-700">{t("pipeRun1")}</span>
        <ArrowRight className="h-3.5 w-3.5 text-neutral-300" />
        <span className="rounded-md border border-dashed border-primary/40 bg-primary/[0.06] px-2 py-1 font-medium text-primary-ink">
          {t("pipeJury")}
        </span>
        <ArrowRight className="h-3.5 w-3.5 text-neutral-300" />
        <span className="rounded-md border border-neutral-200 bg-white px-2 py-1 font-medium text-neutral-700">{t("pipeRun2")}</span>
      </div>
      <ul className="grid list-disc gap-1 pl-5 text-sm leading-6 text-neutral-700">
        <li>{t("explainer1")}</li>
        <li>{t("explainer2")}</li>
        <li>{t("explainer3")}</li>
      </ul>
    </section>
  );
}
